// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"PaymentFormEditionModal_modalFooterButtons__HBxL8"};